import React from 'react'

import { RHFInput } from 'react-hook-form-input'
import useForm from 'react-hook-form'

import { Box, Paper, Typography, TextField } from '@material-ui/core'

import { ButtonGroupForm, Button } from '@yapay/react-components'

import { useSnackbar } from 'hooks'
import * as service from 'service'
import constants from './../../../../../../constants'
import schemas from './../../schemas'
import PaymentMethodsContext from 'contexts/PaymentMethodsContext'

const IntegrationTokenEdit = () => {
  const snackbar = useSnackbar()
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    clearError,
    errors,
  } = useForm({
    validationSchema: schemas.integrationTokenSchema,
  })
  const [edit, setEdit] = React.useState(false)
  const [currentValues, setCurrentValues] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const context = React.useContext(PaymentMethodsContext)

  React.useEffect(() => {
    const loadIntegrationToken = async () => {
      try {
        const responseIntegrationToken = await service.recurrence.settings.get({
          settingId: constants.settings.YAPAY_TOKEN_ACCOUNT,
        })

        setValue(
          'integrationToken',
          responseIntegrationToken.data.setting.value,
        )
      } catch (error) {
      } finally {
        context.setIsLoadingIntegrationToken(false)
      }
    }

    loadIntegrationToken()
    // eslint-disable-next-line
  }, [setValue])

  const handleClickEdit = () => {
    setCurrentValues({ ...getValues() })
    setEdit(true)
  }

  const handleClickCancel = () => {
    Object.keys(currentValues).forEach(key => setValue(key, currentValues[key]))
    clearError('integrationToken')
    setEdit(false)
  }

  const onSubmit = async data => {
    try {
      setIsLoading(true)

      const responsesPaymentMethods = await Promise.all([
        service.recurrence.processors.get({
          processor: 'yapay',
          type: 'b',
        }),
        service.recurrence.processors.get({
          processor: 'yapay',
          type: 'c',
        }),
      ])

      const activePaymentMethods = responsesPaymentMethods.reduce(
        (currentPaymentMethods, response) => {
          return [
            ...currentPaymentMethods,
            ...response.data.paymentMethods
              .filter(paymentMethod => paymentMethod.status)
              .map(paymentMethod => paymentMethod.name),
          ]
        },
        [],
      )

      await Promise.all([
        service.recurrence.settings.update({
          settingId: constants.settings.YAPAY_TOKEN_ACCOUNT,
          value: data.integrationToken,
        }),
        service.recurrence.processors.update({
          processor: 'yapay',
          methods: activePaymentMethods,
          tags: [
            {
              tag: 'token_account',
              value: data.integrationToken,
            },
          ],
        }),
      ])

      snackbar.open({
        message: 'Token de integração alterado com sucesso!',
        variant: 'success',
      })

      setEdit(false)
      setIsLoading(false)
    } catch (error) {
      snackbar.open({
        message: 'Erro ao alterar token de integração! Tente novamente!',
        variant: 'error',
      })

      setIsLoading(false)
    }
  }

  return (
    <Box component={Paper} p={{ xs: 2, sm: 4 }} mb={2}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
        >
          <Box mb={{ xs: 0, sm: 2 }}>
            <Typography variant="h5">Token de integração Yapay</Typography>
          </Box>

          {!edit && (
            <Box display={{ xs: 'none', sm: 'block' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleClickEdit}
                isLoading={context.isLoading}
                disabled={context.isLoading || context.error}
              >
                Editar
              </Button>
            </Box>
          )}
        </Box>

        <Box width={{ xs: 1, sm: 1 / 3 }} mb={2}>
          <RHFInput
            as={
              <TextField
                label="Token de integração"
                error={!!errors?.integrationToken}
                helperText={errors?.integrationToken?.message}
                disabled={context.isLoading || !edit}
                fullWidth
              />
            }
            name="integrationToken"
            register={register}
            setValue={setValue}
          />
        </Box>

        <Box mt={2}>
          <ButtonGroupForm>
            {!edit && (
              <Box display={{ xs: 'block', sm: 'none' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClickEdit}
                  isLoading={context.isLoading}
                  disabled={context.isLoading || context.error}
                  fullWidth
                >
                  Editar
                </Button>
              </Box>
            )}

            {edit && (
              <>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  isLoading={isLoading || context.isLoading}
                  disabled={isLoading || context.isLoading || context.error}
                >
                  Salvar
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleClickCancel}
                >
                  Cancelar
                </Button>
              </>
            )}
          </ButtonGroupForm>
        </Box>
      </form>
    </Box>
  )
}

export default IntegrationTokenEdit
